import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { RoutesEnum } from '@monofront/types';
import useLocalizedRoutes from '@hooks/i18n/useLocalizedRoutes';
import useI18n from '@hooks/i18n/useI18n';

interface IGeneralConditionsProps {
  customStyle?: string;
  isCheckout?: boolean;
}

const GeneralConditions: React.FC<IGeneralConditionsProps> = ({
  customStyle,
  isCheckout,
}) => {
  const { isFrenchMarket, isGermanMarket } = useI18n();
  const { getPath } = useLocalizedRoutes();

  const tAccount = useTranslations('Account');

  if (isGermanMarket) {
    return (
      <p
        className={`${customStyle} tw-text-center tw-text-xs [&>*]:tw-text-black-600`}
      >
        <span className="tw-lf-caption-regular">
          {tAccount(
            isCheckout
              ? 'clickingNextYouAcceptCheckout'
              : 'clickingNextYouAccept',
          )}{' '}
        </span>
        <Link href={getPath(RoutesEnum.LEGAL_CONDITIONS)} legacyBehavior>
          <a
            className="tw-lf-link-inherit"
            data-testid="RegisterByEmailForm-go-to-general-conditions"
          >
            {tAccount('generalConditions')}{' '}
          </a>
        </Link>
        <span className="tw-lf-caption-regular">
          {tAccount('ofCompanyName')}
        </span>
      </p>
    );
  }

  if (isFrenchMarket) {
    return (
      <p
        className={`${customStyle} tw-lf-body-regular-sm [&>a]:tw-lf-link-inherit`}
      >
        <span>
          {tAccount(
            isCheckout ? 'generalConditions1Checkout' : 'generalConditions1',
          )}
        </span>
        <Link href={getPath(RoutesEnum.CGU)}>
          {tAccount('generalConditionsCGU')}
        </Link>
        <span>{tAccount('generalConditions2')}</span>
        <Link href={getPath(RoutesEnum.CGV)}>
          {tAccount('generalConditionsCGV')}
        </Link>
        <span>{tAccount('generalConditions3')}</span>
        <Link href={getPath(RoutesEnum.PRIVACY_POLICIES)}>
          {tAccount('generalConditionsPolicy')}
        </Link>
        <span>{tAccount('generalConditions4')}</span>
      </p>
    );
  }

  return null;
};

export default GeneralConditions;
